import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AdditionalServiceAddonCard } from 'src/app/core/models/additional-service-addon';
import { PermissionsService } from 'src/app/core/services/permissions.service';

@Component({
  selector: 'additional-service-card',
  templateUrl: './additional-service-card.component.html',
  styleUrls: ['./additional-service-card.component.scss'],
  standalone: false,
})
export class AdditionalServiceCardComponent implements OnInit {
  @Input() serviceAddon: AdditionalServiceAddonCard = null;
  @Output() addService: EventEmitter<any> = new EventEmitter<any>();
  @Input() cardColor: 'blue' | 'green' = 'blue';

  buttonText: string = 'Add this feature';

  constructor(private permissionsService: PermissionsService) {}

  ngOnInit(): void {
    if (this.serviceAddon?.isEvergreenTile) {
      this.buttonText = `Show ${this.serviceAddon?.displayName}`;
    }
  }

  onAddService() {
    this.addService.emit(this.serviceAddon.name);
  }

  disableButton() {
    if (this.serviceAddon.name === 'roles-permissions') {
      return !this.permissionsService.hasCompanyAdminPermissions();
    }

    return false;
  }
}
